<script lang="ts">
    import { Col,Button ,Modal, ModalHeader,ModalBody, ModalFooter} from "sveltestrap";
    import { LargeModal, Sizesmodal, SmallModal } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
    let open: boolean = false;
    let size: any;
    let title : string
    const toggle = () => {
        size = undefined;
        open = !open
        title = undefined
    }
    const togglelg = () => {
        size = 'lg';
        open = !open
        title = "Large modal"
    }
    const togglesm = () => {
        size = 'sm';
        open = !open
        title = "Small modal"
    }
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Sizesmodal} CardBodyprops="btn-showcase">
      <div slot="contentbody">
        <!-- Large modal-->
        <Button color="primary" on:click={togglelg}>{LargeModal}</Button>
        <Button color="primary" on:click={togglesm}>{SmallModal}</Button>
        <Modal isOpen={open} {toggle} {size}>
            <ModalHeader {toggle}>
                {title}
                <Button class="btn-close" aria-label="Close" />
            </ModalHeader>
            <ModalBody>...</ModalBody>
        </Modal>
      </div>
    </Card>
</Col>